import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import TrocaSenha from "./TrocaSenha";


const ResetarSenha = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (event === "PASSWORD_RECOVERY") {
          setUser(session?.user ?? null);
          setLoading(false);
        }

        if (event === "SIGNED_IN") {
          setUser(session?.user ?? null);
          setLoading(false);
        }
      },
    );

    // verifica se já existe sessão
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();

      if (data?.session?.user) {
        setUser(data.session.user);
      }

      setLoading(false);
    };

    checkSession();

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  const handlePasswordChanged = () => {
    setTimeout(() => {
      navigate("/login");
    }, 3000);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8 text-center">
        <img
          src="/assets/logo-transparente-parcial.webp"
          alt="Tesourinhos"
          className="w-28 mx-auto mb-6"
        />

        {loading && (
          <>
            <h2 className="text-xl font-bold text-slate-800 mb-2">Verificando acesso</h2>
            <p className="text-sm text-slate-500">
              Aguarde enquanto validamos seu link de recuperação...
            </p>
          </>
        )}

        {!loading && user && (
          <TrocaSenha
            user={user}
            onClose={handlePasswordChanged}
            isRecovery={true}
          />
        )}

        {!loading && !user && (
          <div>
            <h2 className="text-xl font-bold text-slate-800 mb-2">Link inválido ou expirado</h2>
            <p className="text-sm text-slate-500 mb-5">
              O link de redefinição de senha não é mais válido.
            </p>
            <button
              className="h-11 w-full rounded-xl bg-rose-400 text-white font-semibold text-sm hover:brightness-105 transition"
              onClick={() => navigate("/recuperar-senha")}
            >
              Solicitar novo link
            </button>
          </div>
        )}

        {error && <p className="text-xs text-red-600 mt-3">{error}</p>}
      </div>
    </div>
  );
};

export default ResetarSenha;
